import React from 'react';
import { MeetingSection, MeetingVersion } from '../../../shared/types/types';
import { MEETING_SECTION } from '../../../utils/enums';
import TabDivButton from './TabDivButton';

interface AgendaTabButtonAtomProps {
  meetingDataVersion: MeetingVersion,
  meetingTab: MeetingSection,
  onClick: () => void
}

const AgendaTabButtonAtom = ({
  meetingDataVersion,
  meetingTab,
  onClick,
}: AgendaTabButtonAtomProps) => {
  if (meetingDataVersion >= 4) return null;

  return (
    <TabDivButton
      active={meetingTab === MEETING_SECTION.AGENDA}
      disabled={meetingTab === MEETING_SECTION.AGENDA}
      onClick={onClick}
      tooltipText=""
      meetingTab={MEETING_SECTION.AGENDA}
    >
      Agenda
    </TabDivButton>
  );
};

export default AgendaTabButtonAtom;
